/* eslint-disable react/no-this-in-sfc */
import React from 'react';
import PropTypes from 'prop-types';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import Highcharts3D from 'highcharts/highcharts-3d';

Highcharts3D(Highcharts);

const theme = {
  pending: { main: '#FF9800' },
  success: { main: '#4CAF50' },
  primary: { main: '#2196F3' }
};

function OverAllAmount({ data, currency }) {
  const total = data.reduce((sum, item) => sum + item.y, 0);

  const options = {
    chart: {
      type: 'pie',
      options3d: {
        enabled: true,
        alpha: 45,
        beta: 0,
        depth: 60,
        viewDistance: 30
      }
    },
    title: {
      text: 'Invoice Over All Amount (3D)',
      style: { fontSize: '20px', fontWeight: 'bold' }
    },
    accessibility: { enabled: false },
    tooltip: {
      backgroundColor: '#fff',
      style: { color: 'black' },
      formatter() {
        return ((point) => {
          const percentage = ((point.y / total) * 100).toFixed(1);
          return `
            <div style="text-align: center; padding: 5px;">
              <b>${point.name}</b><br/>
              <span style="font-size: 14px;">${currency}${point.y.toLocaleString()}</span><br/>
              <span style="opacity: 0.8;">${percentage}%</span>
            </div>
          `;
        })(this.point);
      }
    },
    colors: [
      theme.pending?.main || '#FF9800',
      theme.success?.main || '#4CAF50',
      theme.primary?.main || '#2196F3'
    ],
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        depth: 45,
        dataLabels: {
          enabled: true,
          format: `<b>{point.name}</b><br/>${currency} {point.y:,.0f}`,
          style: { fontSize: '12px', fontWeight: 'bold' }
        },
        innerSize: '40%',
        states: { hover: { halo: { size: 10 } } }
      }
    },
    series: [
      {
        type: 'pie',
        name: 'Amount',
        colorByPoint: true,
        data: data.map((item, index) => ({
          name: item.name,
          y: item.y,
          selected: index === 0,
          sliced: index === 0
        }))
      }
    ],
    credits: { enabled: false }
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
}

OverAllAmount.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      y: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    })
  ).isRequired,
  currency: PropTypes.string.isRequired
};

export default OverAllAmount;
